<template>
  <div class="order-detail">
    <el-card shadow="never">
      <div slot="header">
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回列表</el-button>
        <span class="header-title">订单详情</span>
      </div>

      <el-row v-loading="loading">
        <!-- 订单状态 -->
        <el-col :span="24" class="section">
          <div class="section-title">订单状态</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="订单编号">{{ detail.order_no }}</el-descriptions-item>
            <el-descriptions-item label="订单状态">
              <el-tag :type="statusTag" size="small">{{ detail.order_status_text }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="下单时间">{{ detail.create_time }}</el-descriptions-item>
            <el-descriptions-item label="支付时间">{{ detail.pay_time || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-col>

        <!-- 用户信息 -->
        <el-col :span="24" class="section">
          <div class="section-title">用户信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="用户昵称">{{ detail.user_name }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ detail.user_phone || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-col>

        <!-- 商品信息 -->
        <el-col :span="24" class="section">
          <div class="section-title">商品信息</div>
          <el-table :data="detail.items" border size="small">
            <el-table-column label="商品图片" width="80">
              <template slot-scope="scope">
                <el-image :src="scope.row.goods_img" style="width:50px;height:50px;border-radius:4px" fit="cover" />
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" min-width="180" />
            <el-table-column prop="sku_spec_text" label="规格" width="120">
              <template slot-scope="scope">{{ scope.row.sku_spec_text || '-' }}</template>
            </el-table-column>
            <el-table-column label="单价" width="100">
              <template slot-scope="scope">&yen;{{ scope.row.sell_price }}</template>
            </el-table-column>
            <el-table-column prop="buy_num" label="数量" width="60" />
            <el-table-column label="小计" width="100">
              <template slot-scope="scope">
                <span class="amount-text">&yen;{{ (scope.row.sell_price * scope.row.buy_num).toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <!-- 订单信息 -->
        <el-col :span="24" class="section">
          <div class="section-title">订单信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="商品类型">{{ detail.goods_type_text }}</el-descriptions-item>
            <el-descriptions-item label="商品来源">{{ detail.supplier_type_text }}</el-descriptions-item>
            <el-descriptions-item label="支付方式">{{ detail.pay_type_text }}</el-descriptions-item>
            <el-descriptions-item label="收货方式">{{ detail.receive_type_text }}</el-descriptions-item>
            <el-descriptions-item label="订单金额">
              <span class="amount-text">&yen;{{ detail.total_amount }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="PV值">{{ detail.total_pv || 0 }}</el-descriptions-item>
          </el-descriptions>
        </el-col>

        <!-- 收货信息 -->
        <el-col :span="24" class="section" v-if="detail.address_info">
          <div class="section-title">收货信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="收货人">{{ detail.address_info.name }}</el-descriptions-item>
            <el-descriptions-item label="联系电话">{{ detail.address_info.phone }}</el-descriptions-item>
            <el-descriptions-item label="收货地址" :span="2">
              {{ detail.address_info.province }}{{ detail.address_info.city }}{{ detail.address_info.district }}{{ detail.address_info.detail }}
            </el-descriptions-item>
          </el-descriptions>
        </el-col>

        <!-- 物流信息 -->
        <el-col :span="24" class="section" v-if="detail.logistics_no">
          <div class="section-title">物流信息</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="快递公司">{{ detail.logistics_company }}</el-descriptions-item>
            <el-descriptions-item label="快递单号">{{ detail.logistics_no }}</el-descriptions-item>
            <el-descriptions-item label="发货时间">{{ detail.delivery_time || '-' }}</el-descriptions-item>
            <el-descriptions-item label="收货时间">{{ detail.confirm_time || '-' }}</el-descriptions-item>
          </el-descriptions>
        </el-col>

        <!-- 臻赏消费券解锁进度 -->
        <el-col :span="24" class="section" v-if="detail.coupon_freeze">
          <div class="section-title">臻赏消费券解锁进度</div>
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="赠送总额">
              <span class="amount-text">&yen;{{ detail.coupon_freeze.total_amount }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="解锁状态">
              <el-tag :type="detail.coupon_freeze.status === 1 ? 'success' : 'warning'" size="small">{{ detail.coupon_freeze.status_text }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="释放天数">{{ detail.coupon_freeze.release_days }} 天</el-descriptions-item>
            <el-descriptions-item label="每日释放">&yen;{{ detail.coupon_freeze.daily_amount }}</el-descriptions-item>
            <el-descriptions-item label="已解锁天数">{{ detail.coupon_freeze.released_days }} 天</el-descriptions-item>
            <el-descriptions-item label="已解锁金额">&yen;{{ detail.coupon_freeze.released_amount }}</el-descriptions-item>
            <el-descriptions-item label="冻结中">&yen;{{ detail.coupon_freeze.frozen_amount }}</el-descriptions-item>
            <el-descriptions-item label="已解冻到余额">&yen;{{ detail.coupon_freeze.unfrozen_amount }}</el-descriptions-item>
          </el-descriptions>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getOrderDetail } from '@/api'

export default {
  name: 'OrderDetail',
  data() {
    return {
      loading: false,
      detail: {}
    }
  },
  computed: {
    statusTag() {
      const map = { 0: 'warning', 1: '', 2: 'info', 3: 'success', 4: 'danger', 5: 'warning', 6: 'info' }
      return map[this.detail.order_status] || 'info'
    }
  },
  mounted() {
    this.loadDetail()
  },
  methods: {
    async loadDetail() {
      const id = this.$route.params.id
      if (!id) {
        this.$message.error('参数错误')
        this.goBack()
        return
      }
      this.loading = true
      try {
        const res = await getOrderDetail({ id })
        this.detail = res.data || res || {}
      } catch (e) {
        this.$message.error(e.message || '获取详情失败')
      }
      this.loading = false
    },
    goBack() {
      this.$router.push('/orders')
    }
  }
}
</script>

<style scoped>
.header-title {
  font-size: 16px;
  font-weight: bold;
  margin-left: 12px;
}
.section {
  margin-top: 20px;
}
.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 3px solid #3a8ee6;
}
.amount-text {
  color: #e6a23c;
  font-weight: bold;
}
</style>
